// extracted by mini-css-extract-plugin
module.exports = {"container":"SubjectBoxes_container__25OUQ","prev-btn":"SubjectBoxes_prev-btn__1vdvQ","next-btn":"SubjectBoxes_next-btn__6l_AS","content":"SubjectBoxes_content__FBBCA"};